import { LayerType } from "../../types";
import { UKPropertyInformationMapLayer } from "./UKPropertyInformationMapLayer";
import { UKPropertyInformationPrintable } from "./UKPropertyInformationPrintable";
import { UKPropertyInformationSelectionSidebar } from "./UKPropertyInformationSelectionSidebar";
import { UKPropertyInformationSummary } from "./UKPropertyInformationSummary";
import { PropertyInformationControlPage } from "./PropertyInformationControlPage";

export const UKPropertyInformationLayerType: LayerType = {
  ControlPage: PropertyInformationControlPage,
  SelectionSidebar: UKPropertyInformationSelectionSidebar,
  MapLayer: UKPropertyInformationMapLayer,
  Printable: UKPropertyInformationPrintable,
  LayerSummary: UKPropertyInformationSummary,
};
